export type ShorthandEnvironmentType = 'STAGING' | 'PROD';
// New canonical localStorage key for Schneider Charge
export const SCHNEIDER_CHARGE_ENV_TYPE_STORAGE_KEY = 'SchneiderChargeEnvType';
export const SCHNEIDER_CHARGE_ENV_TYPE_USER_OVERRIDE_KEY = 'SchneiderChargeEnvTypeUserOverride';
export const DEFAULT_ENV_TYPE_SHORTHAND: ShorthandEnvironmentType = 'PROD';
export let ENV_TYPE_SHORTHAND: ShorthandEnvironmentType = DEFAULT_ENV_TYPE_SHORTHAND;
const viteEnv = (import.meta as unknown as { env?: Record<string, string | undefined> }).env;
const cypressRun = (window as unknown as Record<string, unknown>)['Cypress'];

if (cypressRun) {
  ENV_TYPE_SHORTHAND = 'STAGING';
}

// The clipsal deploy account will always default to DEV, the schneider account will default to prod.
// This is related to the way we handle push notification certs in the back-end system.
// TODO: Re-evaluate this, we should have only one (schneider) deploy account.
if (viteEnv?.VITE_DEPLOY_ACCOUNT === 'clipsal') {
  ENV_TYPE_SHORTHAND = 'STAGING';
}

// Check local storage for a different env setting (users can override this)
let fromStorage = localStorage.getItem(SCHNEIDER_CHARGE_ENV_TYPE_STORAGE_KEY);

// Short-term fix to re-assign DEV to STAGING
if (fromStorage && fromStorage === 'DEV') fromStorage = 'STAGING';

const isValidStoredEnvironment = fromStorage === 'STAGING' || fromStorage === 'PROD';
const hasUserOverride = localStorage.getItem(SCHNEIDER_CHARGE_ENV_TYPE_USER_OVERRIDE_KEY) === 'true';

if (isValidStoredEnvironment && hasUserOverride) {
  ENV_TYPE_SHORTHAND = fromStorage as ShorthandEnvironmentType;
} else if (!cypressRun) {
  // Set default value in local storage if one is missing or invalid.
  localStorage.setItem(SCHNEIDER_CHARGE_ENV_TYPE_STORAGE_KEY, DEFAULT_ENV_TYPE_SHORTHAND);
  localStorage.setItem(SCHNEIDER_CHARGE_ENV_TYPE_USER_OVERRIDE_KEY, 'false');
  ENV_TYPE_SHORTHAND = DEFAULT_ENV_TYPE_SHORTHAND;
}
